import { v4 as uuidv4 } from 'uuid';
import { formatFileSize } from './localFile.js';
import {
	isLocalMediaItem,
	normalizeUploadedAudioItem,
	pickFilesizeByte,
	pickFilesizeLabel,
} from './mediaItem.js';

/** 为 false 时走 uploadMediaToQiniu 真实上传 */
export const USE_LOCAL_AUDIO_MOCK = false;

export const MAX_LOCAL_AUDIO_COUNT = 1;
export const MAX_LOCAL_AUDIO_SIZE = 100 * 1024 * 1024;

const AUDIO_EXT = /\.(mp3|wav|m4a|aac|ogg|flac|wma)$/i;

export function isAudioFilename(filename = '') {
	return AUDIO_EXT.test(filename);
}

export function formatAudioDuration(totalSeconds = 0) {
	const sec = Math.max(0, Math.floor(Number(totalSeconds) || 0));
	const minutes = Math.floor(sec / 60);
	const seconds = sec % 60;
	return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function createLocalAudioItem(file) {
	const previewUrl = URL.createObjectURL(file);
	const baseItem = {
		id: uuidv4(),
		filename: file.name || '',
		filesize: formatFileSize(file.size),
		filesize_byte: file.size,
		previewUrl,
		duration: 0,
		durationText: '00:00',
		url: '',
		local: true,
	};

	return new Promise((resolve) => {
		const audio = new Audio();
		audio.preload = 'metadata';
		audio.onloadedmetadata = () => {
			const duration = Number.isFinite(audio.duration) ? Math.floor(audio.duration) : 0;
			resolve({
				...baseItem,
				duration,
				durationText: formatAudioDuration(duration),
			});
		};
		audio.onerror = () => {
			resolve(baseItem);
		};
		audio.src = previewUrl;
	});
}

export function revokeLocalAudioItem(item) {
	if (item?.previewUrl?.startsWith('blob:')) {
		URL.revokeObjectURL(item.previewUrl);
	}
}

export function revokeLocalAudios(items = []) {
	items.forEach(revokeLocalAudioItem);
}

export function filterValidLocalAudioList(files = [], maxCount = MAX_LOCAL_AUDIO_COUNT) {
	const valid = [];
	for (const file of files) {
		if (!file) continue;
		if (file.size > MAX_LOCAL_AUDIO_SIZE) continue;
		valid.push(file);
		if (valid.length >= maxCount) break;
	}
	return valid;
}

export function normalizeLocalAudioItem(item = {}) {
	if (!isLocalMediaItem(item)) {
		return normalizeUploadedAudioItem(item);
	}
	const duration = item.duration || 0;
	return {
		id: item.id || uuidv4(),
		filename: item.filename || '',
		filesize: pickFilesizeLabel(item),
		filesize_byte: pickFilesizeByte(item),
		previewUrl: item.previewUrl || '',
		duration,
		durationText: item.durationText || formatAudioDuration(duration),
		url: '',
		local: true,
	};
}

export function normalizeLocalAudios(items = []) {
	return items.slice(0, MAX_LOCAL_AUDIO_COUNT).map(normalizeLocalAudioItem);
}

export function normalizeHeaderAudios(data = {}) {
	return {
		items: normalizeLocalAudios(data.items),
	};
}

export function getHeaderAudioItem(data = {}) {
	return normalizeHeaderAudios(data).items[0] || null;
}
